module.exports = __webpack_public_path__ + "img/watermark.32ba7fa5.png";